<script>
export default {
    data() {
		return {
			main_menu: []
		}
	},
	
    computed: {
		topLevelLinks() {
			return this.main_menu.filter(item => {
				return !item.parent
			})
		},

		nestedStructure() {
			let nested = []
			this.topLevelLinks.forEach(top => {
				let children = []
				children = this.main_menu.filter(item => {
					return item.parent && item.parent == top.id
				})

				if (children.length > 0) {
					top.children = children
					top.hasChildren = true
					top.children.forEach(child => {
						let grandchildren = []
						grandchildren = this.main_menu.filter(grandchild => {
							return (
								grandchild.parent &&
								grandchild.parent == child.id
							)
						})

						if (grandchildren.length > 0) {
							child.children = grandchildren
							child.hasChildren = true
						} else {
							child.hasChildren = false
						}
					})
				} else {
					top.hasChildren = false
				}

				nested.push(top)
			})
			return nested
		},
	},

    mounted() {
        // let main_menu = localStorage.getItem("main_menu")
        // let main_menu_date = localStorage.getItem("main_menu_date")
		// if (main_menu) {
		// 	this.main_menu = JSON.parse(main_menu)
		// } else {
			axios
				.get("/main_menu.json")
				.then(response => {
					this.main_menu = response.data.data
					this.$store.commit('main_menu_flat', this.main_menu)
					this.$store.commit('main_menu', this.nestedStructure)
					// localStorage.setItem(
					// 	"main_menu",
					// 	JSON.stringify(this.main_menu)
                    // )
                    // localStorage.setItem(
					// 	"main_menu_date",
					// 	JSON.stringify(new Date())
					// )					
				})
				.catch(e => {
					console.log(e)
				})
		// }
		
    }
}
</script>

<template>
    <div class="hidden"></div>
</template>
